<template>
    <div class="content__body">
        <div class="profile-info profile-info-requisites">
            <div class="profile-info__header">
                Чтобы посмотреть/изменить реквизиты другого доступного вам дилерского центра, переключитесь на него в разделе «Профили ДЦ».
            </div>

            <UILoader v-if="isDealerLoading" class="tableable" />

            <div v-else-if="!isDealerLoading && dealer" class="profile-info__body">
                <div class="profile-info__body-title">{{ dealer.name }}</div>

                <div class="profile-info-detail">
                    <div class="profile-info-detail__list">
                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Марка</div>
                            <div class="profile-info-detail__value">{{ dealerBrands.join(', ') || '' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Код</div>
                            <div class="profile-info-detail__value">{{ dealer.sap_code }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Холдинг</div>
                            <div class="profile-info-detail__value">{{ dealer.holding_name || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Город</div>
                            <div class="profile-info-detail__value">{{ dealer.city_name }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Сайт</div>
                            <div class="profile-info-detail__value">{{ dealer.site || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Телефон</div>
                            <div class="profile-info-detail__value">{{ dealer.phone || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Email</div>
                            <div class="profile-info-detail__value">{{ dealer.email || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Сертифицированный дилер</div>
                            <div class="profile-info-detail__value">{{ dealer.is_certified ? 'Да' : 'Нет' }}</div>
                        </div>
                    </div>

                    <div class="profile-info-detail__subtitle">Юридические данные</div>

                    <div class="profile-info-detail__list">
                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Название юр.лица</div>
                            <div class="profile-info-detail__value">{{ dealer.legal_entity?.name || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">ИНН</div>
                            <div class="profile-info-detail__value">{{ dealer.legal_entity?.inn || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">КПП</div>
                            <div class="profile-info-detail__value">{{ dealer.legal_entity?.kpp || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">ОГРН</div>
                            <div class="profile-info-detail__value">{{ dealer.legal_entity?.ogrn || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Должность подписанта</div>
                            <div class="profile-info-detail__value">{{ dealer.legal_entity?.signer_position || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">ФИО подписанта</div>
                            <div class="profile-info-detail__value">{{ dealer.legal_entity?.signer_fio || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Должность и ФИО подписанта в РП</div>
                            <div class="profile-info-detail__value">
                                {{ dealer.legal_entity?.signatory_position_and_name || '-' }}
                            </div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">На основании (в родительном падеже)</div>
                            <div class="profile-info-detail__value">{{ dealer.legal_entity?.signer_basis || '-' }}</div>
                        </div>

                        <!--<div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Физический адрес дилера</div>
                            <div class="profile-info-detail__value">
                                {{ dealer.legal_entity?.address || '-' }}
                            </div>
                        </div>-->

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Юридический адрес</div>
                            <div class="profile-info-detail__value">
                                {{ dealer.legal_entity?.address || '-' }}
                            </div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Номер договора</div>
                            <div class="profile-info-detail__value">
                                {{ dealer.legal_entity?.contract_number || '-' }}
                            </div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Дата договора</div>
                            <div class="profile-info-detail__value">
                                {{ dealer.legal_entity?.contract_date || '-' }}
                            </div>
                        </div>
                    </div>

                    <div class="profile-info-detail__subtitle">Банковские реквизиты</div>

                    <div class="profile-info-detail__list">
                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Расчетный счет</div>
                            <div class="profile-info-detail__value">{{ dealer.legal_entity?.bank_account || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Название банка</div>
                            <div class="profile-info-detail__value">{{ dealer.legal_entity?.bank_name || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">Корр. Счет</div>
                            <div class="profile-info-detail__value">{{ dealer.legal_entity?.correspondent_account || '-' }}</div>
                        </div>

                        <div class="profile-info-detail__row">
                            <div class="profile-info-detail__label">БИК</div>
                            <div class="profile-info-detail__value">{{ dealer.legal_entity?.bank_identification_code || '-' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="!isDealerLoading && dealer" class="content__footer">
        <div class="form__actions">
            <router-link :to="{ name: 'EditRequisites' }">
                <UISimpleButton class="profile-info__button">
                    <template #icon>
                        <img v-svg-inline src="@/assets/icons/ui/edit.svg" />
                    </template>
                    Редактировать
                </UISimpleButton>
            </router-link>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed, onMounted, ref } from 'vue';

    import { Dealer } from '@/types/dealer.type.ts';

    import useDealerRepository from '@/repositories/dealer/useDealerRepository.ts';
    import useUserRepository from '@/repositories/user/useUserRepository.ts';

    import UILoader from '@/components/ui/UILoader/UILoader.vue';
    import UISimpleButton from '@/components/ui/UISimpleButton/UISimpleButton.vue';

    const { isDealerLoading, getDealer } = useDealerRepository();
    const { getCurrentUser } = useUserRepository();

    const dealer = ref<Dealer | null>(null);

    const dealerBrands = computed<string[]>(() => {
        if (dealer.value === null) {
            return [];
        }

        const brands: string[] = [];

        if (dealer.value.is_hyundai_dealer) {
            brands.push('Hyundai');
        }

        if (dealer.value.is_genesis_dealer) {
            brands.push('Genesis');
        }

        return brands;
    });

    function fetchDealer(): void {
        const userCurrentDealerId = getCurrentUser().dealer_id;

        if (!userCurrentDealerId) {
            dealer.value = null;

            return;
        }

        getDealer(userCurrentDealerId).then((fetchedDealer: Dealer) => {
            dealer.value = fetchedDealer;
        });
    }

    onMounted(() => {
        fetchDealer();
    });
</script>

<style scoped lang="scss">
    @use 'RequisitesTab' as *;
</style>
